import 'vant/lib/index.less';
import 'element-ui/lib/theme-chalk/index.css'; // elemetn ui 样式表
import '@jcy/css/iconfont/iconfont.css';
import '@jcy/css/iconfont-mobile/iconfont-mobile.css'; // 移动端名片配置 iconfont
import '@jcy/css/base/style.css';
import '@jcy/css/pages/tfganChart.css';
import '@jcy/css/vendor/jquery.atwho.css';
import Vue from 'vue';
import App from './App.vue';
import router from './router/index.js'; // 路由
import store from './store'; // vuex 数据库
import VueBus from './common/js/bus'; // vue bus 事件总线
import Element from 'element-ui';
import i18n from './locale/i18n'; // 国际化
import { tfMessage } from '@/common/js/message-tf.js'; // elemetn ui 提示框重新封装
/** 过滤器 */
import filters from '@/filter/filter.js'; // 管道过滤器
/** 自定义指令 */
import directives from '@/directive/directive.js'; // 自定义指令集合
import draggable from 'vuedraggable'; // 全局拖动组件
import VueXss from 'vue-xss';
import { initEnv, getTokenLocal } from '@jcy/shared';
import { setupAppVersionCheck } from './common/js/app-version';
setupAppVersionCheck({
    currentVersion: process.env.VUE_APP_VERSION,
    baseUrl: process.env.PUBLIC_PATH || '/',
    enabled: process.env.VUE_APP_VERSION_CHECK_ENABLED === 'true'
});
initEnv({
    baseUrl: () => process.env.VUE_APP_BASE_URL,
    token: () => getTokenLocal(),
    env: () => process.env.VUE_APP_NODE_ENV,
    loginUrl: () => '',
    debug: () => true
});
const xssOptions = {
    // 白名单
    whiteList: {
        a: ['style', 'href', 'title', 'target'],
        p: ['style'],
        section: ['style'],
        strong: ['style'],
        abbr: ['title', 'style'],
        address: ['style'],
        area: ['style', 'shape', 'coords', 'href', 'alt'],
        article: ['style'],
        aside: ['style'],
        audio: ['style', 'autoplay', 'controls', 'loop', 'preload', 'src'],
        b: ['style'],
        bdi: ['style', 'dir'],
        bdo: ['style', 'dir'],
        big: ['style'],
        blockquote: ['style', 'cite'],
        br: ['style'],
        caption: ['style'],
        center: ['style'],
        cite: ['style'],
        code: ['style'],
        col: ['style', 'align', 'valign', 'span', 'width'],
        colgroup: ['style', 'align', 'valign', 'span', 'width'],
        dd: ['style'],
        del: ['style', 'datetime'],
        details: ['style', 'open'],
        div: ['style', 'style'],
        dl: ['style'],
        dt: ['style'],
        em: ['style'],
        font: ['style', 'color', 'size', 'face'],
        footer: ['style'],
        h1: ['style'],
        h2: ['style'],
        h3: ['style'],
        h4: ['style'],
        h5: ['style'],
        h6: ['style'],
        header: ['style'],
        hr: ['style'],
        i: ['style'],
        img: ['style', 'src', 'alt', 'title', 'width', 'height'],
        ins: ['style', 'datetime'],
        li: ['style'],
        mark: ['style'],
        nav: ['style'],
        ol: ['style'],
        pre: ['style'],
        s: ['style'],
        small: ['style'],
        span: ['style'],
        sub: ['style'],
        sup: ['style'],
        table: ['width', 'border', 'align', 'valign', 'style'],
        tbody: ['style', 'align', 'valign'],
        td: ['width', 'rowspan', 'colspan', 'align', 'valign', 'style'],
        tfoot: ['style', 'align', 'valign'],
        th: ['style', 'width', 'rowspan', 'colspan', 'align', 'valign'],
        thead: ['style', 'align', 'valign'],
        tr: ['style', 'rowspan', 'align', 'valign'],
        tt: ['style'],
        u: ['style'],
        ul: ['style'],
        video: ['style', 'autoplay', 'controls', 'loop', 'preload', 'src', 'height', 'width'],
        style: ['style'] // 新添
    },
    // 去掉不在白名单上的标签
    stripIgnoreTag: true,
    // 去掉HTML备注
    allowCommentTag: false,
    // 彻底去除script标签
    stripIgnoreTagBody: ['script', 'noscript']
};
Vue.use(VueXss, xssOptions);
// Vue.config.devtools = true
Object.keys(filters).forEach(key => {
    const filter = filters[key];
    if (typeof filter === 'function') {
        Vue.filter(key, filter);
    }
});
Object.keys(directives).forEach(key => {
    const directive = directives[key];
    if (directive) {
        Vue.directive(key, directive);
    }
});
// 注册到全局
// eslint-disable-next-line vue/multi-word-component-names
Vue.component('draggable', draggable);
Vue.use(Element);
Vue.use(VueBus);
Vue.config.productionTip = false;
Vue.config.devtools = false; // 浏览器 vue 插件
// 2021-06-21 自定义message处理
Vue.prototype.$tfMessage = tfMessage;
window.vm = new Vue({
    el: '#app',
    i18n,
    router,
    store,
    components: { App },
    template: '<App/>'
});
